import { getEntityAPIClient as e, registerEntityEndpoint as t } from "@editor/ui-utils";
//#region src/services/newsletter.service.ts
var n = "newsletter", r = t(n), { getEntity: i, listEntities: a, putEntity: o, postEntity: s, deleteEntity: c } = r, l = async (e) => i(e), u = async (e) => c(e), d = async (t) => (await e(n).get("/recipient-groups", { params: { brand: t } })).data, f = () => ({
	_id: "placeholderUuid",
	title: "",
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		isRenderedByCTF: !0,
		hasBeenModifiedInCTF: !0
	}
});
//#endregion
export { d as a, l as i, u as n, f as r, r as t };

//# sourceMappingURL=newsletter.service-b1LnfKOo.js.map